import { TitleWrapper } from './title-wrapper';

type StepperFormHeaderProps = {
	title: string;
	description: string;
	titleHTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	asHtmlString?: boolean;
};

export const StepperFormHeader = ({
	title,
	description,
	titleHTag = 'h1',
	asHtmlString = false,
}: StepperFormHeaderProps) => {
	return (
		<div className="flex w-full flex-col spacing-stack-m">
			<TitleWrapper
				asHtmlString={asHtmlString}
				title={title}
				titleHTag={titleHTag}
				className="text-h3 text-text-heading [&_a]:text-text-heading [&_a]:underline [&_a]:decoration-solid [&_a]:text-text-heading [&_a]:decoration-1 [&_a]:underline-offset-3 [&_a]:[text-decoration-skip-ink:none]"
			/>
			<div
				className="text-body2 text-text-primary [&_a]:text-text-primary [&_a]:underline [&_a]:decoration-solid [&_a]:text-text-primary [&_a]:decoration-1 [&_a]:underline-offset-3 [&_a]:[text-decoration-skip-ink:none]"
				dangerouslySetInnerHTML={{ __html: description }}
			/>
		</div>
	);
};
